<template>
  <div class="footer">
    <div class="mx-auto w-full text-left">
      <div class="footer-img-container flex md:flex-row flex-wrap">
        <div class="footer-img1-wrap">
          <a
            href="https://www.allerganeyecare.com/"
            target="_blank"
            v-ga="
              $ga.commands.trackExternalLink.bind(
                this,
                'https://www.allerganeyecare.com/'
              )
            "
            ><img class="footer-img1" src="static/img/allergan_Footer_CR.png"
          /></a>
        </div>
        <div class="footer-img2-wrap"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "Footer",
  computed: {
    ...mapState([
      "app_state",
      "page_state",
      "current_section",
      "footer_additional_links",
      "sections",
      "sections_content",
      "site_config"
    ]),
    ...mapGetters(["footerBarSections", "sectionContent", "eventTag"]),

    can_show_menu() {
      return (
        (this.$store.state.app_state == 0 &&
          this.$store.state.page_state != 2) ||
        this.$store.state.app_state != 0
      );
    },
    footer_btn_class() {
      let str = "rounded inline-block py-3 px-2 md:px-6 rounded text-white ";
      if (this.site_config.use_footer_as_links) {
        str += "underline hover:text-gray-300";
      } else {
        str +=
          "shadow-md bg-footer-btn-color hover:bg-footer-btn-color-hover hover:shadow-lg";
      }
      return str;
    },
    show_isi() {
      if (this.current_section < 0 || this.current_section == "") return false;

      return (
        "undefined" !=
        typeof this.sections_content.isi.subids[this.current_section]
      );
    }
  },
  methods: {
    getCurrentISIContent(section_id) {
      return this.sectionContent("isi").subids[section_id];
    },
    on_section_click(e, section_id) {
      e.preventDefault();
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        if (section.id == section_id) {
          this.$store.dispatch("set_current_section", section.id);
          this.$store.dispatch("set_popup_state", section.popup_type);
          try {
            this.$ga.event(this.eventTag + "menubar", "click", section.name, 1);
          } catch (err) {}
          break;
        }
      }
    },
    on_footer_content_click(e, section) {
      this.$store.dispatch("set_secondary_section", {
        section: "footer",
        sub_section: section
      });

      this.$store.dispatch(
        "set_popup_state",
        this.sections_content["footer"].subids[section].type
      );
    },
    on_footer_link_click(e, link_index) {
      try {
        this.$ga.event(
          this.eventTag + "footerlink",
          "click",
          this.footer_additional_links[i].title,
          1
        );
      } catch (err) {}
    },
    on_footer_isi_click() {
      this.$store.dispatch("set_secondary_section", {
        section: "isi",
        sub_section: this.current_section
      });
      this.$store.dispatch(
        "set_popup_state",
        this.getCurrentISIContent(this.current_section).type
      );
    },

    get_this() {
      return this;
    }
  }
};
</script>
<style>
.footer {
  margin-top: auto;
  padding: 0px 10px 5px;
  background: transparent;
  margin-top: 0px;
  z-index: 10;
}
.footer .footer-img1-wrap {
  max-width: 36%;
}
.footer .footer-img2-wrap {
  margin-left: auto;
  flex-grow: 0;
  max-width: 62%;
}
.footer .footer-img1 {
  height: auto;
  display: inline-block;
  max-width: 35vw;
  width: 100%;
  image-rendering: crisp-edges;
}
.footer .footer-img2 {
  height: auto;
  display: inline-block;
  max-width: 61vw;
  width: 100%;
  image-rendering: crisp-edges;
}
@media only screen and (min-width: 820px) {
  .xfooter img {
    max-width: 815px;
  }
}
@media only screen and (max-width: 820px) {
  .footer img {
    max-width: 815px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue